import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { UserRole, type IvJwt } from '@/types/common.types';
import { NoSessionTokensError } from './errors';

/** Port of auth-utils.ts. These Amplify APIs are framework-agnostic. */

export async function getLoginId(): Promise<string> {
  const currentUser = await getCurrentUser();
  return currentUser?.signInDetails?.loginId ?? '';
}

export async function getIdTokenJwt(): Promise<IvJwt> {
  const session = await fetchAuthSession();
  if (!session.tokens?.idToken) {
    throw new NoSessionTokensError();
  }
  return session.tokens.idToken as IvJwt;
}

export async function getUserPhoneNumber(): Promise<string> {
  const jwt = await getIdTokenJwt();
  const rawPn = jwt.payload.phone_number;
  if (rawPn && rawPn.startsWith('+1') && rawPn.length === 12) {
    // Format is +19999999999
    return `(${rawPn.substring(2, 5)}) ${rawPn.substring(5, 8)}-${rawPn.substring(8, 12)}`;
  }
  return 'unknown';
}

export async function isAdministrator(): Promise<boolean> {
  const jwt = await getIdTokenJwt();
  return jwt.payload['custom:appRole'] === UserRole.ADMINISTRATOR;
}
